import { Accordion, Button, Col, Container, Row } from "react-bootstrap";
import { useParams, Link } from "react-router-dom";
import allControls from "./controls.json";
function Control() {
  let { familyId, controlId } = useParams();
  let family = allControls.find((c) => c.Family === familyId);
  let control = family.Controls.find(
    (c) => c["Control Identifier"] === controlId
  );
  let relatedControls = control["Related Controls"].split(",");

  return (
    <Container className="py-4">
      <h2>
        {control["Control Identifier"]}:{" "}
        {control["Control (or Control Enhancement) Name"]}
      </h2>
      <Row>
        <Col>
          <h3>Control Text:</h3>
        </Col>
        <Col xs={2}>
          <Button
            variant="outline-info"
            onClick={() => {
              navigator.clipboard.writeText(control["Control Text"]);
            }}
          >
            Copy Text
          </Button>
        </Col>
      </Row>
      <p>{control["Control Text"]}</p>
      {control.Discussion && (
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Discussion</Accordion.Header>
            <Accordion.Body>{control.Discussion}</Accordion.Body>
          </Accordion.Item>
        </Accordion>
      )}
      {control["Related Controls"] && (
        <>
          <h3 className="pt-4">Related Controls</h3>
          <ul style={{ whiteSpace: "wrap" }}>
            {relatedControls.map((control) => {
              if (control === "None")
                return (
                  <li
                    style={{
                      display: "inline-block",
                      listStyleType: "none",
                      paddingRight: "20px",
                    }}
                  >
                    {control}
                  </li>
                );
              else
                return (
                  <li
                    style={{
                      display: "inline",
                      listStyleType: "none",
                      paddingRight: "20px",
                    }}
                  >
                    <Link
                      to={`/${control
                        .trim()
                        .substring(0, 2)}/${control.trim()}`}
                    >
                      {control}
                    </Link>
                  </li>
                );
            })}
          </ul>
        </>
      )}
    </Container>
  );
}

export default Control;
